import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { ProductData } from 'src/app/models/pool-parameters/pool-parameters.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PoolManagerService } from 'src/app/services/pool-manager/pool-manager.service';
import { Subject } from 'rxjs';

export enum EditOption {
  PRICE = 0,
  MARGIN = 1,
}

@Component({
  selector: 'app-edit-product-parameters-modal',
  templateUrl: './edit-product-parameters-modal.component.html',
  styleUrls: ['./edit-product-parameters-modal.component.css'],
})
export class EditProductParametersModalComponent {
  EditOption = EditOption;
  currencySymbol: string = '€';

  productData!: ProductData;
  PrincipalProductName!: string;
  private originalProductData!: ProductData;
  ProductDataForm!: FormGroup;
  OptionSelected: EditOption = EditOption.MARGIN;

  onClose: Subject<any> = new Subject();

  SaveLoading: boolean = false;

  constructor(
    private BsModalRef: BsModalRef,
    private poolSvc: PoolManagerService
  ) {}

  ngOnInit() {
    if (this.productData) {
      this.setProductDataForm(this.productData);
    }

    this.ProductDataForm.valueChanges.subscribe((data) => {
    });
  }

  closeModal(productData?: ProductData) {
    this.onClose.next(productData);
    this.onClose.complete();
    this.BsModalRef.hide();
  }
  setProductDataForm(productData: ProductData): void {
    this.ProductDataForm = new FormGroup({
      freelancePoolConfigurationGuid: new FormControl(
        this.productData.freelancePoolConfigurationGuid,
        Validators.required
      ),
      poolPrice: new FormControl(
        this.productData.poolPrice,
        Validators.required
      ),
      poolProfitMargin: new FormControl(
        this.productData.poolProfitMargin,
        Validators.required
      ),
      productDescription: new FormControl(this.productData.productDescription),
      productKey: new FormControl(
        this.productData.productKey,
        Validators.required
      ),
    });
    this.originalProductData = { ...this.ProductDataForm.value };
  }

  saveParameters(): void {
    this.SaveLoading = true;
    let ProductDataModify = this.buildProductDataObj();
    this.closeModal(ProductDataModify);
    //   this.poolSvc.updateFreelancePoolConfigurationPrice(ProductDataModify).subscribe((data) => {
    //   },
    //     (error) => {
    //     })
  }

  buildProductDataObj(): ProductData {
    return {
      freelancePoolConfigurationGuid: this.ProductDataForm.get(
        'freelancePoolConfigurationGuid'
      )?.value,
      poolPrice: this.ProductDataForm.get('poolPrice')?.value,
      poolProfitMargin: this.ProductDataForm.get('poolProfitMargin')?.value,
      productDescription: this.ProductDataForm.get('productDescription')?.value,
      productKey: this.ProductDataForm.get('productKey')?.value,
    };
  }

  selectOption(option: EditOption) {
    this.OptionSelected = option;
  }

  get isFormModified(): boolean {
    return this.shallowCompare(
      this.ProductDataForm.value,
      this.originalProductData
    );
  }

  shallowCompare(a: any, b: any): boolean {
    return Object.keys(a).some((key) => a[key] !== b[key]);
  }
}
